import api from '../../thesaurus-api'
import {
  REGIONS_LOAD_DATA,
  REGIONS_LOAD_DATA_SUCCESS,
  REGIONS_LOAD_DATA_FAILED
} from '../mutations/available'
import {RequestState} from "../../requestState";

export const getAllRegions = async ({commit}) => {
  commit(REGIONS_LOAD_DATA);

  let allRegions = null;
  try {
    allRegions = await api.getAllRegions();
    commit(REGIONS_LOAD_DATA_SUCCESS, allRegions)
  } catch (e) {
    commit(REGIONS_LOAD_DATA_FAILED, e);
    console.error(`Unable to get initial data, details: ${e.message}`)
  }

  return allRegions
};

export async function fetchAllRegions({commit, dispatch, state}) {
  if (state.fetchAllRegions === RequestState.Success ||
      state.fetchAllRegions === RequestState.Loading) {
    return
  }

  return dispatch('getAllRegions')
}




// WEBPACK FOOTER //
// ./src/store/actions/regions.js